import instance  from './axios'

// 获取租客列表
export const lesseeGetList = (para) => {
  return instance.post('/lessee/getList', para)
}

//租客行业统计
export const lesseeGetBusinessStat = (para) => {
  return instance.get('/lessee/getBusinessStat', {params: para})
}

//租客预警列表
export const lesseeGetWarnList = (para) => {
  return instance.get('/lessee/getWarnList', {params: para})
}

//启用/禁用人员接口
export const toggle = (para) => {
  return instance.post('/account/toggle/status', para)
}

//获取租客工商信息
export const getBusinessInfo = (para) => {
  return instance.get('/lessee/getBusinessInfo', {params: para})
}


//租客股东信息
export const getStockInfo = (para) => {
  return instance.get('/lessee/getStockInfo', {params: para})
}

//租客企业变更
export const getEnterpriseChangeInfo = (para) => {
  return instance.get('/lessee/getEnterpriseChangeInfo', {params: para})
}

//租客企业裁判文书
export const getDocumentInfo = (para) => {
  return instance.get('/lessee/getDocumentInfo', {params: para})
}

//租客执行信息
export const getLoseCreditInfo = (para) => {
  return instance.get('/lessee/getLoseCreditInfo', {params: para})
}

//租客立案信息列表
export const getCaseList = (para) => {
  return instance.get('/lessee/getCaseList', {params: para})
}